import React from "react";
import "../styles/Apamvm.css";
import ApamvmImg from "../assets/photos/apamvm.png";

function Apamvm() {
  return (
    <div className="apamvm-wrapper">

      <section className="apamvm-hero">
          <h1>Annasaheb Patil Arthik Magas Vikas Mahamandal</h1>
            <p>
            A financial development initiative by the Government of
            Maharashtra to support economically backward youth
            through self-employment and financial assistance schemes.
          </p>
          <div className="apamvm-badge">
                    Interest Subsidy Scheme
          </div>
      </section>

      <section className="apamvm-objective">
       <a href="https://udyog.mahaswayam.gov.in/#/home"> <img src={ApamvmImg} alt="info-apamvm-banner"/></a>
       <h6>Click the Banner to Know More.</h6>
        <h2>Objective of the Scheme</h2>

        <p>
          The scheme aims to promote entrepreneurship and provide
          financial assistance to eligible individuals for starting
          businesses, self-employment activities, and small industries.
        </p>

        <p>
          It helps improve the economic status of beneficiaries and
          encourages sustainable income generation.
        </p>

      </section>

      <section className="apamvm-schemes">

        <h2>Financial Assistance Schemes</h2>

        <div className="scheme-grid-apamvm">

          <div className="scheme-card-apamvm">
            <h3>Business Loan</h3>
            <p>
              Financial support for starting new business ventures
              and small scale enterprises.
            </p>
          </div>

          <div className="scheme-card-apamvm">
            <h3>Self Employment Loan</h3>
            <p>
              Assistance for individuals willing to start
              self-employment activities.
            </p>
          </div>

          <div className="scheme-card-apamvm">
            <h3>Entrepreneurship Support</h3>
            <p>
              Encouragement for youth to develop entrepreneurial
              ventures and generate employment.
            </p>
          </div>

        </div>

      </section>

      <section className="apamvm-eligibility">

        <h2>Eligibility Criteria</h2>

        <ul className="eligibility-list">

          <p>1) Applicant must be a resident of Maharashtra.</p>
          <p>2) Applicant should belong to economically backward category.</p>
          <p>3) Age criteria as defined by the scheme guidelines.</p>
          <p>4) Applicant should have a valid bank account.</p>
          <p>5) Must submit required documents during application.</p>

        </ul>

      </section>

      <section className="apamvm-process">

        <h2>Application Process</h2>

        <div className="process-steps">

          <div className="process-card-apamvm">
            <span>1</span>
            <p>Visit the nearest bank branch.</p>
          </div>

          <div className="process-card-apamvm">
            <span>2</span>
            <p>Collect the application form.</p>
          </div>

          <div className="process-card-apamvm">
            <span>3</span>
            <p>Submit required documents.</p>
          </div>

          <div className="process-card-apamvm">
            <span>4</span>
            <p>Application verification and approval.</p>
          </div>

        </div>

      </section>

      <section className="apamvm-documents">

        <h2>Documents Required</h2>

        <div className="document-grid-apamvm">

          <div className="doc-card-apamvm">Aadhaar Card</div>
          <div className="doc-card-apamvm">PAN Card</div>
          <div className="doc-card-apamvm">Address Proof</div>
          <div className="doc-card-apamvm">Bank Passbook</div>
          <div className="doc-card-apamvm">Income Certificate</div>
          <div className="doc-card-apamvm">Photographs</div>

        </div>

      </section>

      <section className="apamvm-notice">

        <h3>Important Information</h3>

        <p>
          Applicants are advised to contact the nearest bank branch
          for detailed information about eligibility, loan limits,
          and application procedures.
        </p>

      </section>

      <section className="apamvm-download">

        <a href="/forms/apamvm-form(sample).pdf" className="download-btn">
          Download Form
        </a>

      </section>

    </div>
  );
}

export default Apamvm;